import * as R from 'ramda'

const INVITATION = 'invite.mail'
const REMINDER = 'reminder.mail'

const CREATED = 'created'
const INVITED = 'invited'

export const MESSAGES_FIELD = 'messages'

export const DEADLINE_FIELD = 'deadline'
export const KIND_FIELD = 'kind'
export const MESSAGE_FIELD = 'message'
export const RECEIVER_FIELD = 'receiver'
export const SENDER_FIELD = 'sender'
export const SUBJECT_FIELD = 'subject'
export const TEMPLATE_ID_FIELD = 'templateId'

export const MESSAGE_TYPES = { INVITATION, REMINDER }

export const STATUSES = {
  [CREATED]: MESSAGE_TYPES.INVITATION,
  [INVITED]: MESSAGE_TYPES.REMINDER,
}

export const getTemplate = state => {
  const { language, status, templates } = state

  return R.find(
    R.both(
      R.propEq('language', language),
      R.propEq('message_type', STATUSES[status]),
    ),
  )(templates)
}
